<template>
  <div class="card-container">
    <article class="card teaser-card color__white">
       <!-- TODO: Comment in if add to favorite neeeds to be used! -->
      <!-- <button
        type="button"
        :class="['btn add-favorite vue', { 'in-list' : addedDocuments.includes(card.id)}]"
        title="Tilføj til ønskeliste"
        :data-favoriteid="card.id"
        data-bs-toggle="modal"
        data-bs-target="#userModal"
        @click="showWishlistModal"
      >
      </button> -->
      <picture v-if="card.imageSlide">
        <v-lazy-image
          class="img-fluid"
          :src="card.imageSlide"
          src-placeholder="/public/img/placeholder.gif?mode=crop&width=360&height=640"
          width="360"
          height="640"
          :alt="card.imageAltText"
        >
        </v-lazy-image>
      </picture>
      <picture v-else>
        <img
          class="img-fluid"
          src="/public/img/placeholder.gif?mode=crop&width=360&height=640"
          width="360"
          height="640"
          data-src=""
          alt="placeholder image"
        />
      </picture>
      <div
        :class="[
          { 'flip-text-bg': card.hasFliptext },
          'card__content-wrapper text-center',
        ]"
      >
        <div class="text-uppercase fs-6 fw-bold text-shadow py-2 px-3">
          {{ card.destination }}
        </div>
        <div class="card__content position-relative h-100 w-100 flex-grow-1">
          <!-- Default content -->
          <div
            :class="[
              { 'default-no-flip-text': !card.hasFliptext },
              ' default d-flex flex-column justify-content-end px-3',
            ]"
          >
            <h3 class="h3 text-shadow">
              <a class="header-link" :href="card.url">{{ card.title }}</a>
            </h3>
            <div
              class="pt-4 fw-bold text-shadow"
              v-if="card.numberOfDays && card.fromPrice"
            >
              <p class="text-uppercase text-shadow fs-6 mb-0">
                {{ card.numberOfDays }} dage fra
              </p>
              <p class="fs-4 text-shadow mb-0">{{ card.fromPrice }}</p>
            </div>
          </div>

          <!-- content on hover -->
          <div class="hover d-flex align-items-center" v-if="card.hasFliptext">
            <div class="rte-text w-100 px-4">
              <h4 class="fs-4 text-markpro fw-bold text-shadow mb-2">
                {{ card.teaserFlipTextHeadline }}
              </h4>
              <p
                class="text-shadow"
                v-for="(bullet, index) in card.teaserFlipTextBullets"
                :key="index"
              >
                {{ bullet }}
              </p>
            </div>
          </div>
        </div>
        <div class="p-4">
          <a :href="card.url" class="btn border rounded-pill" @mousedown="preventFocus"> Se rejsen </a>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import VLazyImage from "v-lazy-image";
export default {
  name: "PageTravelCard",
  props: ["card"],
  components: {
    VLazyImage,
  },
  computed: {
    addedDocuments() {
      return this.$store.state.addedDocuments ?? [];
    }
  },
  methods: {
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
    showWishlistModal: function(event) {
      const favoriteId = document.getElementById("favoriteId");
      favoriteId.value = this.card.id;
      var change = new Event('change');
      favoriteId.dispatchEvent(change);
    }
  },
};
</script>